import { TableIcon } from "./TableIcon";

export const CircularTableIcon = (props) => <TableIcon shape="circle" {...props} />;
